import { useState } from 'react';
import { appContent } from '@/mocks/home';

export default function AppSection() {
  const [mockupError, setMockupError] = useState(false);
  const [qrError, setQrError] = useState(false);

  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {appContent.title}
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-md mx-auto lg:mx-0">
              {appContent.subtitle}
            </p>

            <div className="mt-6 space-y-3">
              {appContent.features.map((f, i) => (
                <div key={i} className="flex items-center gap-3 justify-center lg:justify-start">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-700">{f}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#"
                className="px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
              >
                <i className="ri-android-line mr-2"></i>
                Android 下载
              </a>
              <a
                href="#"
                className="px-6 py-3 text-sm font-medium bg-foreground-900 text-background-50 rounded-full whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-all duration-200"
              >
                <i className="ri-apple-line mr-2"></i>
                iOS 下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none flex items-center justify-center gap-6">
            {!mockupError && (
              <div className="relative w-48 md:w-56">
                <img
                  src={appContent.mockupImage}
                  alt="被窝影院App界面"
                  className="w-full h-auto rounded-2xl"
                  onError={() => setMockupError(true)}
                />
              </div>
            )}
            {!qrError && (
              <div className="flex flex-col items-center gap-3">
                <div className="w-28 h-28 md:w-32 md:h-32 rounded-xl overflow-hidden bg-background-50 border border-background-200/70 p-2">
                  <img
                    src={appContent.qrImage}
                    alt="被窝影院App下载二维码"
                    className="w-full h-full object-contain"
                    onError={() => setQrError(true)}
                  />
                </div>
                <span className="text-xs text-foreground-500">扫码下载App</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}